import React from "react";

export const BackendInfoContext = React.createContext({});
